// extracted by css-extract-rspack-plugin
export default {"cls1":"dossier-cls1_MpR","cls2":"dossier-cls2_oYh dossier-cls1_MpR"};